import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { DashboardService } from '../dashboard.service';
import { LoginRegisterService } from '../../login-register/login-register.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {


  todayDate = new Date();
  results: any;
  activityLog: any;
  assessmentStats: any;
  filterOptions = [{
    id: 'TODAY',
    value: 'Today'
  }, {
    id: 'YESTERDAY',
    value: 'Yesterday'
  },
  {
    id: 'LAST_WEEK',
    value: 'Last Week'
  },
  {
    id: 'LAST_MONTH',
    value: 'Last Month'
  }
  ];

  selectedFilter: any;

  startEndDateSelection = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  constructor(
    private dashboardService: DashboardService,
    private router: Router,
    private loaderService: LoaderService,
    private storage: StorageMap,
    private loginRegisterService: LoginRegisterService) { }

  ngOnInit() {
    this.selectedFilter = 'LAST_MONTH';
    this.getAssessmentStats();
    this.getActivityLog();
  }

  applyCustomRange(): void {
    this.getActivityLog('custom');
    this.getAssessmentStats('custom');
  };

  private getActivityLog(type = null) {
    this.loaderService.show('Loading activity log');
    let filterValues = type ? `startdate=${new Date(this.startEndDateSelection.value.start)}&enddate=${new Date(this.startEndDateSelection.value.end)}` : `filterBy=${this.selectedFilter}`;
    this.dashboardService.activityLog(filterValues).subscribe((res) => {
      this.activityLog = res.docs;
      this.loaderService.hide();
    }, () => {
      this.loaderService.hide();
    });
  }

  private getAssessmentStats(type = null) {
    this.loaderService.show('Loading assessment statistics');
    let filterValues = type ? `startdate=${new Date(this.startEndDateSelection.value.start)}&enddate=${new Date(this.startEndDateSelection.value.end)}` : `filterBy=${this.selectedFilter}`;
    this.dashboardService.getAssessmentStats(filterValues).subscribe((response) => {
      this.assessmentStats = response;
      this.results = [
        {
          id: 1,
          count: response.invited,
          label: 'Invited',
          icon: 'assets/invitation.svg'
        },
        {
          id: 2,
          count: response.assessed,
          percentage: (response.assessed / (response.invited === 0 ? 1 : response.invited)) * 100,
          phrase: 'of total invitations',
          label: 'Assessed',
          icon: 'assets/ok.svg'
        },
        {
          id: 3,
          count: response.qualified,
          percentage: (response.qualified / (response.assessed === 0 ? 1 : response.assessed)) * 100,
          phrase: 'of total assessments',
          label: 'Qualified',
          icon: 'assets/qualify.svg'
        }
      ];
      this.loaderService.hide();
    }, (err) => {
      // Safe check for session expiration (401)
      if (err?.error?.errors?.[0]?.code === 401) {
        // Use centralized session cleanup method
        this.loginRegisterService.clearSessionData();
        this.router.navigate([`verify-entrepreneur/resend-verify-token`]);
      }
      this.loaderService.hide();
    });
  }

  filterChange(option): void {
    if (option.value === 'custom') {
      return;
    }
    this.getActivityLog();
    this.getAssessmentStats();
  }

  /** Open Assessment */
  activityLogDetails(item) {
    if (item.isNewAssessment) {
      this.router.navigate(['/dashboard/assessments/update/' + item._id]);
    } else {
      this.router.navigate(['/dashboard/assessments/invites/' + item._id]);
    }
  }

  getActivityIcon(notification: string): string {
    const text = notification.toLowerCase();
    if (text.includes('started')) return 'play_arrow';
    if (text.includes('invited')) return 'send';
    if (text.includes('created')) return 'add_circle';
    if (text.includes('completed')) return 'task_alt';
    return 'notifications';
  }

  getActivityColor(notification: string): string {
    const text = notification.toLowerCase();
    if (text.includes('started')) return 'started';
    if (text.includes('invited')) return 'invited';
    if (text.includes('created')) return 'created';
    if (text.includes('completed')) return 'completed';
    return 'default';
  }

  formatNotification(notification: string): string {
    if (!notification) return '';
    // Bold the first word (usually the username)
    // And bold the date part if it starts with "at "
    return notification
      .replace(/^([^ ]+)/, '<strong>$1</strong>')
      .replace(/at (\d{2} [A-Z][a-z]{2} \d{4}, \d{2}:\d{2}:\d{2} [ap]m)/, 'at <strong>$1</strong>');
  }

}
